import {
  StyleSheet,
  Text,
  View,
  ScrollView,
  TouchableOpacity,
  Image,
} from "react-native";
import React, { useState } from "react";
import InputText from "../../../../components/InputText";
import { Button, useTheme } from "react-native-paper";
import { Feather } from "@expo/vector-icons";
import useApi from "../../../../hooks/useAPI";
import { SafeAreaView } from "react-native-safe-area-context";
import { showMessage } from "react-native-flash-message";
import * as ImagePicker from "expo-image-picker";
import * as FileSystem from "expo-file-system";
import { createFormDataFileFromURI } from "../../../../utils/ImageFunctions";
import { Dropdown } from "react-native-material-dropdown";
import { useForm, Controller } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import createCardSecondStepSchema from "../../../../schemas/createCardSecondStepSchema";
import { mask } from "react-native-mask-text";
import LinearLoading from "../../../../components/LinearLoading";
type inputsData = {
  educationLevel: string;
  uf: string;
  city: string;
  name: string;
  cpf: string;
  rg: string;
  photo: string;
  course: string;
};

type Props = {
  studentId: string;
  institution: string;
  dob: string;
  navigation: any;
};

const CreateCardSecondStepScreen = ({
  studentId,
  institution,
  dob,
  navigation,
}: Props) => {
  const { colors } = useTheme();
  const api = useApi();
  const [loading, setLoading] = useState(false);
  const [img, setImg] = useState("");
  const [showCourse, setShowCourse] = useState(false);
  const [cpfError, setCpfError] = useState(false);
  const [limitImgSizeError, setLimitImgSizeError] = useState(false);
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<inputsData>({
    resolver: joiResolver(createCardSecondStepSchema),
  });
  const pickImage = async () => {
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      aspect: [9, 11],
      quality: 1,
    });
    console.log("aba");
    console.log(result);
    if (!result.cancelled) {
      setImg(result.uri);
    }
  };
  function validarCPF(cpf: string) {
    if (cpf == undefined) {
      setCpfError(false);
      return true;
    }
    cpf = cpf.replace(/[^\d]+/g, "");
    if (cpf == "") {
      setCpfError(false);
      return true;
    }
    // Elimina CPFs invalidos conhecidos
    if (
      cpf.length != 11 ||
      cpf == "00000000000" ||
      cpf == "11111111111" ||
      cpf == "22222222222" ||
      cpf == "33333333333" ||
      cpf == "44444444444" ||
      cpf == "55555555555" ||
      cpf == "66666666666" ||
      cpf == "77777777777" ||
      cpf == "88888888888" ||
      cpf == "99999999999"
    ) {
      setCpfError(true);
      return false;
    }
    // Valida 1o digito
    let add = 0;
    for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(cpf.charAt(9))) {
      setCpfError(true);
      return false;
    }
    // Valida 2o digito
    add = 0;
    for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(cpf.charAt(10))) {
      setCpfError(true);
      return false;
    }
    setCpfError(false);
    return true;
  }
  function properEdLevel(educationLevel: string) {
    switch (educationLevel) {
      case "Educação infantil":
        return "Ensino infantil";
      case "Ensino fundamental":
        return "Ensino fund";
      case "Ensino médio":
        return "Ensino médio";
      case "Ensino superior":
        return "Ensino superior";
    }
  }
  const onSubmit = async (data: inputsData) => {
    if (limitImgSizeError) return;
    if (validarCPF(data.cpf) !== true) return;
    setLoading(true);
    try {
      const file = createFormDataFileFromURI(data.photo);
      let formData = new FormData();

      formData.append("education_level", properEdLevel(data.educationLevel));
      formData.append("uf", data.uf);
      formData.append("city", data.city);
      formData.append("name", data.name);
      formData.append("cpf", data.cpf ? data.cpf.replace(/[^\d]+/g, "") : "");
      formData.append("rg", data.rg ? data.rg.replace(/[^\d]+/g, "") : "");
      formData.append("photo", file, "photo.png");
      formData.append(
        "course",
        data.educationLevel !== "Ensino superior"
          ? properEdLevel(data.educationLevel)
          : data.course
      );
      formData.append("dob", dob);
      formData.append("institution", institution);
      formData.append("student_id", studentId);
      formData.append("position", "Student");

      await api.createCard.postCard(formData);
      console.log(formData);
      showMessage({ type: "success", message: "Carteira criada." });
      navigation.navigate("AuthStack", {
        screen: "Login",
      });
      setLoading(false);
    } catch (e: any) {
      console.log(e);
      showMessage({ type: "danger", message: "Erro durante o envio!" });
      setLoading(false);
    }
  };

  return (
    <SafeAreaView style={styles.root}>
      <ScrollView contentContainerStyle={styles.container}>
        <View style={styles.header}>
          <Text style={styles.subtitle}>
          Agora, insira as informações para cadastro da carteira.

          </Text>
        </View>

        <View style={{ width: "100%", paddingHorizontal: 24 }}>
          <View>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <InputText
                  placeholder="Nome*"
                  value={value}
                  onChange={onChange}
                  style={[
                    styles.inputs,
                    {
                      borderColor: errors.name
                        ? colors.error
                        : colors.inputBackgroundColor,
                    },
                  ]}
                  selectionColor={colors.primary}
                  textColor={errors.name ? colors.error : colors.text}
                  placeholderTextColor={
                    errors.name ? colors.error : colors.text
                  }
                  disabled={loading}
                />
              )}
              name="name"
            />
          </View>
          <View>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Dropdown
                  label="Grau de escolaridade:"
                  data={[
                    { value: "Educação infantil" },
                    { value: "Ensino fundamental" },
                    { value: "Ensino médio" },
                    { value: "Ensino superior" },
                  ]}
                  onChangeText={(value, index, data) => {
                    onChange(value, index, data);
                    value === "Ensino superior"
                      ? setShowCourse(true)
                      : setShowCourse(false);
                  }}
                  value={value}
                  baseColor={
                    errors?.educationLevel ? colors.error : colors.primary
                  }
                  labelFontSize={16}
                  onBlur={onBlur}
                  disabled={loading}
                />
              )}
              name="educationLevel"
            />
          </View>
          {showCourse && (
            <View>
              <Controller
                control={control}
                rules={{
                  required: true,
                }}
                render={({ field: { onChange, onBlur, value } }) => (
                  <InputText
                    placeholder="Curso*"
                    value={value}
                    onChange={onChange}
                    style={[
                      styles.inputs,
                      {
                        borderColor: errors.course
                          ? colors.error
                          : colors.inputBackgroundColor,
                      },
                    ]}
                    selectionColor={colors.primary}
                    textColor={errors.course ? colors.error : colors.text}
                    placeholderTextColor={
                      errors.course ? colors.error : colors.text
                    }
                    disabled={loading}
                  />
                )}
                name="course"
              />
            </View>
          )}
          <View>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Dropdown
                  label="UF:"
                  data={[
                    { value: "AC" },
                    { value: "AL" },
                    { value: "AP" },
                    { value: "AM" },
                    { value: "BA" },
                    { value: "CE" },
                    { value: "DF" },
                    { value: "ES" },
                    { value: "GO" },
                    { value: "MA" },
                    { value: "MT" },
                    { value: "MS" },
                    { value: "MG" },
                    { value: "PA" },
                    { value: "PB" },
                    { value: "PR" },
                    { value: "PE" },
                    { value: "PI" },
                    { value: "RJ" },
                    { value: "RN" },
                    { value: "RS" },
                    { value: "RO" },
                    { value: "RR" },
                    { value: "SC" },
                    { value: "SP" },
                    { value: "SE" },
                    { value: "TO" },
                  ]}
                  onChangeText={onChange}
                  value={value}
                  baseColor={errors?.uf ? colors.error : colors.primary}
                  labelFontSize={16}
                  onBlur={onBlur}
                  disabled={loading}
                />
              )}
              name="uf"
            />
          </View>

          <View>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <InputText
                  placeholder="Cidade*"
                  value={value}
                  onChange={onChange}
                  style={[
                    styles.inputs,
                    {
                      borderColor: errors.city
                        ? colors.error
                        : colors.inputBackgroundColor,
                    },
                  ]}
                  selectionColor={colors.primary}
                  textColor={errors.city ? colors.error : colors.text}
                  placeholderTextColor={
                    errors.city ? colors.error : colors.text
                  }
                  disabled={loading}
                />
              )}
              name="city"
            />
          </View>

          <View>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <InputText
                  placeholder="CPF"
                  value={value}
                  onChange={(value) => {
                    const maskedValue = mask(value, "999.999.999-99");
                    onChange(maskedValue);
                    validarCPF(maskedValue);
                  }}
                  style={[
                    styles.inputs,
                    {
                      borderColor: cpfError
                        ? colors.error
                        : colors.inputBackgroundColor,
                    },
                  ]}
                  selectionColor={colors.primary}
                  textColor={cpfError ? colors.error : colors.text}
                  placeholderTextColor={cpfError ? colors.error : colors.text}
                  disabled={loading}
                />
              )}
              name="cpf"
            />
          </View>

          <View>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <InputText
                  placeholder="RG"
                  value={value}
                  onChange={onChange}
                  style={[
                    styles.inputs,
                    {
                      borderColor: errors.rg
                        ? colors.error
                        : colors.inputBackgroundColor,
                    },
                  ]}
                  selectionColor={colors.primary}
                  textColor={errors.rg ? colors.error : colors.text}
                  placeholderTextColor={errors.rg ? colors.error : colors.text}
                  disabled={loading}
                />
              )}
              name="rg"
            />
          </View>

          <View>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange } }) => (
                <TouchableOpacity
                  style={[
                    styles.addPicture,
                    {
                      borderColor: errors.photo
                        ? colors.error
                        : colors.inputBackgroundColor,
                    },
                  ]}
                  onPress={async () => {
                    let result = await ImagePicker.launchImageLibraryAsync({
                      mediaTypes: ImagePicker.MediaTypeOptions.Images,
                      allowsEditing: true,
                      aspect: [9, 11],
                      quality: 1,
                    });
                    if (!result.cancelled) {
                      const uri = result.uri;
                      onChange(uri);
                      setImg(uri);
                      let newResult = await FileSystem.getInfoAsync(uri);
                      if (newResult.size > 5000000) {
                        setLimitImgSizeError(true);
                      } else {
                        setLimitImgSizeError(false);
                      }
                    }
                  }}
                >
                  <Text
                    style={[
                      styles.addPictureText,
                      { color: errors.photo ? colors.error : colors.text },
                    ]}
                  >
                    Inserir foto para carteirinha*
                  </Text>
                  <Feather
                    name="camera"
                    size={16}
                    color={errors.photo ? colors.error : colors.text}
                    style={styles.cameraIcon}
                  />
                </TouchableOpacity>
              )}
              name="photo"
            />
          </View>

          {/* <TouchableOpacity style={styles.addPicture} onPress={pickImage}>
						<Text style={styles.addPictureText}>
							Inserir foto para carteirinha*
							<Feather name="camera" size={16} color="#999" />
						</Text>
					</TouchableOpacity> */}
          <View
            style={{
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            
              {img ? (
                <Image
                  source={{ uri: img }}
                  style={{
                    width: 180,
                    height: 220,
                    borderColor: limitImgSizeError ? colors.error : "#fff",
                    borderWidth: 1.5,
                  }}
                />
              ): null}
            {limitImgSizeError && (
              <Text
                style={{
                  color: colors.error,
                  marginTop: 5,
                  textAlign: "center",
                }}
              >
                O limite de tamanho da imagem é 5Mb, por favor envie outra ou
                redimensione a que você escolheu.
              </Text>
            )}
          </View>
          <View style={{alignItems: "center",marginBottom:100}}>
            <Button
              style={styles.btn}
              labelStyle={styles.btnText}
              mode="contained"
              onPress={handleSubmit(onSubmit)}
              disabled={loading}
            >
              Continuar
            </Button>
            {loading ? <LinearLoading /> : <View style={styles.emptyLoader} />}
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};
export default CreateCardSecondStepScreen;
const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: "#fff",
    padding: -25,
  },
  container: {
    alignItems: "center",
    // borderColor: "#ff0000",
    // borderWidth: 1,
  },
  inputs: {
    marginTop: 12,
    width: "100%",
    zIndex: 0,
    borderWidth: 1,
    color: "#999999",
  },
  header: {
    width: "100%",
		paddingHorizontal: 24,
  },
  title: {
    fontWeight: "600",
    fontSize: 32,
    marginBottom: 12,
  },
  subtitle: {
    fontWeight: "200",
    fontSize: 15,
    marginBottom: 16,
  },
  btn: {
    marginTop: 20,
    marginBottom: 10,
    borderRadius: 25,
    //width: "90%",
    height: 50,
    width:"100%" ,
  },
  btnText: {
    color: "#fff",
    fontSize: 15,
    lineHeight: 30,
  },
  card: {
    marginTop: 10,
    marginBottom: 10,
    width: "90%",
    backgroundColor: "rgba(199,210,209,0.3)",
    borderRadius: 25,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    height: 50,
    paddingHorizontal: 24,
    justifyContent: "center",
  },
  placeHolder: {
    fontSize: 15,
    fontWeight: "300",
  },
  cardContent: {
    position: "absolute",
    left: 25,
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",
  },
  inputsMargin: {
    marginBottom: 16,
  },
  addPicture: {
    marginTop: 10,
    marginBottom: 10,
    backgroundColor: "rgba(199,210,209,0.3)",
    borderRadius: 25,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    height: 50,
    paddingHorizontal: 24,
    justifyContent: "center",
    borderWidth: 1,
    alignItems: "center",
    flex: 1,
    flexDirection: "row",
  },
  addPictureText: {
    color: "#999999",
    marginRight: 5,
  },
  cameraIcon: {},
  maskedInput: {
    borderWidth: 2,
    borderRadius: 6,
    width: "80%",
    padding: 12,
    color: "black",
    fontSize: 20,
  },
  dobInput: {
    marginTop: 10,
    marginBottom: 10,
    //width: "90%",
    backgroundColor: "rgba(199,210,209,0.3)",
    borderRadius: 25,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    height: 50,
    paddingHorizontal: 24,
    justifyContent: "center",
    borderWidth: 1,
  },
  emptyLoader: {
    height: 4,
  },
});
